module.exports = {"id":"200601","name":"Yoon Bit Garam","rating":"72","photo":"./data/images/photos/3/200601.png","club":{"name":"Sangju Sangmu","logo":"./data/images/clubs/SangjuSangmu.png"},"positions":["MC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/YoonBitGaram0.json
// module id = 4422
// module chunks = 0